import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ColumnProviderService } from './column-provider.service';
import { ColumnDefinitionBase } from '@myarvato/shared/table';

@Injectable({
  providedIn: 'root',
})
export class UserColumnService {
  // injections
  private readonly columnProviderService = inject(ColumnProviderService);

  public getUserColumns(): Observable<ColumnDefinitionBase[]> {
    const allColumns: ColumnDefinitionBase[] = this.columnProviderService.getColumns();

    // Should be delivered by the backend later
    const userColumns: ColumnDefinitionBase[] = allColumns.slice(0, 12);
    return of(userColumns);
  }
}
